// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { requestMagicLink } from '@/authentication/api/request-magic-link';
import { useMutation } from '@tanstack/react-query';

/** Emails a sign-in link to the given address. */
export function useRequestMagicLink() {
  return useMutation({
    mutationFn: (variables: { email: string; redirectURL?: string }) =>
      requestMagicLink(variables.email, variables.redirectURL),
  });
}
